import { chunk, flatten } from "lodash";
import request from "../utils/request";

export async function getDiscoveryPins({
  user_id,
  category,
  limit,
  since,
  max,
}) {
  if (user_id && user_id !== "default") {
    return request({
      url: `/user/${user_id}/feeds`,
      query: {
        limit,
        since,
        max,
      },
    });
  }
  return request({
    url: `/discovery/${category}`,
    query: {
      limit,
      since,
      max,
    },
  });
}

export async function getDiscoveryRecommend(query) {
  return request({
    url: "/pins/recommend/winnow",
    query: {
      ...query,
      fields: "pins:PIN",
    },
  });
}

export async function getDiscoveryMaterials({ limit, page }) {
  return request({
    url: "/materials/pins",
    query: {
      limit,
      page,
    },
  });
}

export async function getDiscoveryBoards({ category, limit, since, max }) {
  return request({
    url: `/discovery/${category}/boards`,
    query: {
      limit,
      since,
      max,
      fields: "boards:BOARD",
    },
  });
}

export async function getDiscoveryTopics() {
  return request({
    url: `/topics`,
  });
}

// https://yapi.gaoding.com/project/1536/interface/api/115780
/**
 * @typedef {{
 *  cover: {bucket: string, farm: string, file_id: number, height: number, key: string, type: string, width: number},
 *  description: string,
 * is_hidden: 0|1,
 * keyword_id: number,
 * name: string,
 * tags: {
 *  must: string[],
 *  should: string[],
 * },
 * urlname: string,
 * }} Explore
 * @returns {Promise<{explores: Explore[]}>}
 */
export async function getDiscoveryExplores({ pins, limit, theme } = {}) {
  return request({
    url: `/explores`,
    query: {
      limit,
      pins,
      theme,
    },
  });
}
/**
 * 根据id集合获取画板信息
 * https://yapi.gaoding.com/project/1536/interface/api/134808
 * @param {number[]} ids
 * @returns
 */
export async function getBoardsListByIds(ids, pins = 4) {
  // 分隔ids，一次请求最多返回20个画板
  const chunks = chunk(ids, 20);

  const all = await Promise.all(
    chunks.map((item) =>
      request({
        url: "/boards/batch",
        query: {
          pins,
          cover: true,
          board_ids: item,
        },
      })
    )
  );

  const boards = flatten(all.map((item) => item?.boards || []));
  return {
    err: all.find((item) => item.err)?.err,
    boards,
  };
}

/**
 * 根据id集合获取用户信息
 * @param {number[]} ids
 * @returns
 */
export async function getUsersListByIds(ids) {
  return request({
    url: "/users/batch",
    query: {
      user_ids: ids,
    },
  });
}

/**
 * 开启画板在灵感页显示
 * @param {number} boardId 画板ID
 * @returns {Promise}
 */
export async function enableBoardInDiscovery(boardId) {
  return request({
    url: `/inspiration/${boardId}`,
    method: "POST",
  });
}

/**
 * 关闭画板在灵感页显示
 * @param {number} boardId 画板ID
 * @returns {Promise}
 */
export async function disableBoardInDiscovery(boardId) {
  return request({
    url: `/inspiration/${boardId}`,
    method: "DELETE",
  });
}

/**
 * 查询画板是否在灵感页显示
 * @param {number} boardId 画板ID
 * @returns {Promise<{selected: boolean}>}
 */
export async function getBoardDiscoveryStatus(boardId) {
  return request({
    url: `/inspiration/${boardId}/selected`,
    method: "GET",
  });
}

/**
 * 获取用户在发现页展示的所有灵感画板
 * @returns {Promise<{boards: Array}>}
 */
export async function getUserInspirationBoards() {
  return request({
    url: `/inspiration`,
    method: "GET",
  });
}
